import React from 'react';
import styled from 'styled-components';
import { StackPanel } from '@agilepoint/wat-react-ux';
// import { NotificationContainer } from '../containers';
import { useConfigScopeSelectors } from '../scopes';
import { UserDetails } from './parts/user-details';

interface INavBarFooterProps {
    isMenuCollapsed: boolean;
}

const HorizontalSeparator = styled.div`
  width: 100%;
  height: 1px;
  box-sizing: border-box;
  margin: unset;
  background-color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant5};
`;

const StyledStackPanel = styled(StackPanel) <{ isMenuCollapsed: boolean }>`
    width: ${({ isMenuCollapsed }) => (isMenuCollapsed ? '40px' : '258px')}; 
    flex-direction: column;
    box-sizing: border-box;
    gap: ${({ isMenuCollapsed }) => (isMenuCollapsed ? '8px' : '16px')};
    padding: ${({ isMenuCollapsed }) => (isMenuCollapsed ? '0' : '0 20px')};
`;

export function NavBarFooter(props: INavBarFooterProps) {
    const { isMenuCollapsed } = props;
    const { selectCurrentUserDetails, isUserTypeAdmin } = useConfigScopeSelectors();
    const { userName, fullName, userOrgInfo: profileImage } = selectCurrentUserDetails();
    const isAdminTypeUser = isUserTypeAdmin();

    const renderSeperator = React.useCallback(() => (
        <>
            {
                isMenuCollapsed ? <></> :
                    <HorizontalSeparator />
            }
        </>
    ), [isMenuCollapsed]);

    return (
        <StyledStackPanel isMenuCollapsed={isMenuCollapsed} separator={renderSeperator}>
            {/* Note: Disabled temporarily - feedback from Sharma */}
            {/* <NotificationContainer isMenuCollapsed={isMenuCollapsed} /> */}
            <UserDetails isMenuCollapsed={isMenuCollapsed} userName={userName} fullName={fullName}
                profileImage={profileImage} isAdminTypeUser={isAdminTypeUser} />
        </StyledStackPanel>
    );
}
